import { isArray } from 'lodash'
import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { IInputNumberProps } from 'components/uiKit/InputNumber'
import InputNumber from 'components/uiKit/InputNumber'

import * as s from './FieldNumberArray.module.scss'

export interface IArrayOption extends Omit<IInputNumberProps, 'name' | 'value' | 'onChange'> {
  icon?: string | JSX.Element
}

interface IProps extends Omit<IInputNumberProps, 'value' | 'onChange' | 'defaultValue'> {
  options: IArrayOption[]
}

const FieldNumberArray = ({
  name,
  onChange,
  options,
  defaultValue,
  value = defaultValue,
  ...rest
}: AdapterKitControlProps<IProps, (number | null)[]>) => {
  const handleChange = useCallback(
    (value: (number | null)[]) => onChange({ name, value }),
    [name, onChange],
  )

  const onChangeIndex = (index: number) => (inputValue: number | null) => {
    const updatedValues = options.map((_option, i) => {
      if (i === index) {
        return inputValue ?? null
      }

      return (isArray(value) ? value : isArray(defaultValue) ? defaultValue : [])[i] ?? null
    })

    handleChange(updatedValues)
  }

  return (
    <div className={s.inputWrapper}>
      {options.map((val, i) => (
        <div className={s.item} key={i}>
          <InputNumber
            {...rest}
            name={`${name}.${i}`}
            onChange={onChangeIndex(i)}
            value={isArray(value) ? value[i] : isArray(defaultValue) ? defaultValue[i] : null}
          />
          <div className={s.icon}>{val.icon}</div>
        </div>
      ))}
    </div>
  )
}

export default React.memo(FieldNumberArray) as typeof FieldNumberArray
